import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import LandingPage from './LandingPage';
import SecondLandingPage from './SecondLandingPage';
import SecondLandingPageApi from './SecondLandingPageApi';
import ThirdLandingPage from './ThirdLandingPage';
import { useRouteError } from 'react-router-dom';

const ErrorElement = () => {
    const error = useRouteError();

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Oops! Something went wrong</h1>
            <p>{error?.statusText || error?.message || 'An unexpected error occurred'}</p>
            <button onClick={() => window.location.href = '/'}>Go Home</button>
        </div>
    );
};

const router = createBrowserRouter([
    {
        path: 'second-page',
        element: <SecondLandingPage />,
        errorElement: <ErrorElement />,
    },
    {
        path: 'second-page-api',
        element: <SecondLandingPageApi />,
        errorElement: <ErrorElement />,
    },
    {
        path: 'third-page',
        element: <ThirdLandingPage />,
        errorElement: <ErrorElement />,
    },
    {
        path: '*',
        element: <SecondLandingPageApi />,
        errorElement: <ErrorElement />,
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router} />);